import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { ShiftModel } from 'app/models/shift.model';

export interface ShiftStockItem {
    supply_id: number;
    current_stock: number;
    supply_name?: string;
}

export interface ShiftStockResponse {
    stock: ShiftStockItem[];
    totalConsumed: number;
    finalStock: number;
    services: any[];
}

@Injectable({ providedIn: 'root' })
export class ShiftsService extends BaseService<ShiftModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'shifts', 'shift_id');
    }

    getStock(shiftId: number, company_id: number) {
        const $request = this.api.getSub<ShiftStockResponse>(`${this.endpoint}/${shiftId}/stock`, { company_id });
        return this.withPromise($request);
    }

    getSupplyMovements(shiftId: number, company_id: number) {
        const $request = this.api.getSub<any[]>(`${this.endpoint}/${shiftId}/supply-movements`, { company_id });
        return this.withPromise($request);
    }

    getServices(shiftId: number) {
        const $request = this.api.getSub<any[]>(`${this.endpoint}/${shiftId}/services`, {});
        return this.withPromise($request);
    }

    /** Alocações-plantão das pessoas deste turno (aba Alocações). */
    getAllocations(shiftId: number) {
        const $request = this.api.getSub<any[]>(`${this.endpoint}/${shiftId}/allocations`, {});
        return this.withPromise($request);
    }

    addUser(shiftId: number, user_id: number) {
        const $request = this.api.postSub(`${this.endpoint}/${shiftId}/users`, { user_id });
        return this.withPromise($request);
    }

    removeUser(shiftId: number, userId: number) {
        const $request = this.api.deleteSub(`${this.endpoint}/${shiftId}/users/${userId}`);
        return this.withPromise($request);
    }

    listNonConformities(shiftId: number) {
        const $request = this.api.getSub<any[]>(`${this.endpoint}/${shiftId}/nonconformities`, {});
        return this.withPromise($request);
    }

    createNonConformity(shiftId: number, body: { description: string; action?: string; status: 'OPEN' | 'CLOSED'; responsible_user_id?: number | null }) {
        const $request = this.api.postSub(`${this.endpoint}/${shiftId}/nonconformities`, body);
        return this.withPromise($request);
    }

    updateNonConformity(shiftId: number, ncId: number, body: { description?: string; action?: string; status?: 'OPEN' | 'CLOSED'; responsible_user_id?: number | null }) {
        const $request = this.api.putSub(`${this.endpoint}/${shiftId}/nonconformities/${ncId}`, body);
        return this.withPromise($request);
    }

    deleteNonConformity(ncId: number) {
        const $request = this.api.deleteSub(`ambulance_shift_non_conformity/${ncId}`);
        return this.withPromise($request);
    }

    getMeasurements(shift_id: number, page?: number, limit?: number) {
        const params: Record<string, string | number> = {};
        if (page != null) params['page'] = page;
        if (limit != null) params['limit'] = limit;
        const $request = this.api.getSub<any>(`${this.endpoint}/${shift_id}/measurements`, params);
        return this.withPromise($request);
    }

    getSecurityEvents(shift_id: number) {
        const $request = this.api.getSub<any>(`${this.endpoint}/${shift_id}/security-events`);
        return this.withPromise($request);
    }
}
